/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Resolution data
 * @export
 * @interface ResolveVulnerabilityRequest
 */
export interface ResolveVulnerabilityRequest {
    /**
     * 
     * @type {string}
     * @memberof ResolveVulnerabilityRequest
     */
    effectTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolveVulnerabilityRequest
     */
    assetId?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolveVulnerabilityRequest
     */
    resolutionMethod?: ResolveVulnerabilityRequestResolutionMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof ResolveVulnerabilityRequest
     */
    notes?: string;
}


/**
 * @export
 */
export const ResolveVulnerabilityRequestResolutionMethodEnum = {
    Patched: 'PATCHED',
    WorkaroundApplied: 'WORKAROUND_APPLIED',
    AssetDecommissioned: 'ASSET_DECOMMISSIONED',
    FalsePositive: 'FALSE_POSITIVE',
    ConfigurationChange: 'CONFIGURATION_CHANGE'
} as const;
export type ResolveVulnerabilityRequestResolutionMethodEnum = typeof ResolveVulnerabilityRequestResolutionMethodEnum[keyof typeof ResolveVulnerabilityRequestResolutionMethodEnum];


/**
 * Check if a given object implements the ResolveVulnerabilityRequest interface.
 */
export function instanceOfResolveVulnerabilityRequest(value: object): value is ResolveVulnerabilityRequest {
    return true;
}

export function ResolveVulnerabilityRequestFromJSON(json: any): ResolveVulnerabilityRequest {
    return ResolveVulnerabilityRequestFromJSONTyped(json, false);
}

export function ResolveVulnerabilityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveVulnerabilityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'resolutionMethod': json['resolutionMethod'] == null ? undefined : json['resolutionMethod'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function ResolveVulnerabilityRequestToJSON(json: any): ResolveVulnerabilityRequest {
    return ResolveVulnerabilityRequestToJSONTyped(json, false);
}

export function ResolveVulnerabilityRequestToJSONTyped(value?: ResolveVulnerabilityRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'effectTenantId': value['effectTenantId'],
        'assetId': value['assetId'],
        'resolutionMethod': value['resolutionMethod'],
        'notes': value['notes'],
    };
}

